import api from "../api";

export const fetchPractitionerAgreements = id =>
  api.user.fetchPractitionerAgreements(id);
export const updatePractitionerAgreements = ({
  agreement_id,
  accepted,
  agreement_name
}) =>
  api.user.updatePractitionerAgreements({
    agreement_id,
    accepted,
    agreement_name
  });
